export default __webpack_public_path__ + "static/Peter-c460ab9df8a2fdcfcaa0c132a2d1eaf9.jpg";